/**
 * Returns current product tariff ID depending on the single or multi-account product type.
 *
 * @param product
 * @return {number}
 */
export default (product) => {
    const productId = product?.product_id;
    let result = 0;
    // doBoard has accounts.
    if (productId === 7) {
        result = product?.account_current_tariff_id || product?.current_tariff_id;
    } else {
        result = product?.current_tariff_id;
    }
    return result;
}
